module.exports = __webpack_public_path__ + "img/1745567661_usaK.02d4768a.jpg";